module.exports = __webpack_public_path__ + "img/concrete.4888c00b.png";